import { useQueryResponse } from '../../core/QueryResponseProvider'
import { termosColumns } from './columns/_columns'
import { TermoConsentimento } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListFilters } from '../../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'

export const TermosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum termo encontrado para “${filters.titulo.trim()}”`}
      description='Revise o título digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum termo cadastrado'
      description='Use “Nova versão” para publicar o primeiro termo de consentimento.'
    />
  )

  return (
    <CustomTable<TermoConsentimento>
      id='kt_table_termos'
      ariaLabel='Termos de consentimento'
      itemLabel={{ singular: 'versão', plural: 'versões' }}
      data={response?.data || []}
      columns={termosColumns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
